var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"row mx-0"},[_c('menuPrincipal',{attrs:{"menus":_vm.menus}}),_c('div',{staticClass:"px-0 border br-10 ml-3 bg-white"},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }